import { calculateTotalPrice } from "../calculateTotalPrice";
import { calculateTargetUtilRate } from "../countOfferPrice";
import { countRemovalDayPrice } from "../countRemovalDayPrice";
import { countRemovalMonthPrice } from "../countRemovalMonthPrice";
import { getSurplusRange } from "../getSurplusRange";
import { countPriceCoefficient } from "./countPriceCoefficient";
import { isRerent } from "./isRerent";
import { isSalesOrService } from "./isSalesOrService";

export const getOfferTotalCoefficients = (offerItems: any[]): number => {
  const totalPrice = offerItems.reduce((acc, offerItem) => {
    if (isSalesOrService(offerItem) || isRerent(offerItem)) {
      return acc; // Skip sales items
    }

    return acc + calculateTotalPrice(offerItem, "TWODECIMALS");
  }, 0);

  let totalPriceWithPriceFactor = 0;

  offerItems.forEach((offerItem) => {
    if (isSalesOrService(offerItem) || isRerent(offerItem)) {
      return;
    }

    let priceFactor = null;

    const rentalRange = {
      start: new Date(offerItem.leasePeriodStart),
      end: new Date(offerItem.leasePeriodEnd),
    };
    const surplusRange = getSurplusRange(offerItem, rentalRange);
    const targetUtilRate = calculateTargetUtilRate(
      rentalRange,
      offerItem.avgRentalPeriod,
      offerItem.targetUtilRate,
      surplusRange,
    );
    if (offerItem.pricingBasis === "DAY") {
      const removalDayPrice = countRemovalDayPrice(
        Number(offerItem?.rentalReadyPrice),
        Number(offerItem?.depreciationPeriod),
        Number(targetUtilRate),
      );
      if (removalDayPrice) {
        priceFactor = countPriceCoefficient(
          offerItem.dayPrice,
          removalDayPrice,
        );
      }
    } else {
      const removalMonthPrice = countRemovalMonthPrice(
        Number(offerItem?.rentalReadyPrice),
        Number(offerItem?.depreciationPeriod),
        Number(targetUtilRate),
      );
      if (removalMonthPrice) {
        priceFactor = countPriceCoefficient(
          offerItem.monthPrice,
          removalMonthPrice,
        );
      }
    }
    if (priceFactor !== null) {
      const total = calculateTotalPrice(offerItem, "TWODECIMALS");
      totalPriceWithPriceFactor += total * priceFactor;
    }
  });

  const priceWeightedPriceFactor = totalPriceWithPriceFactor / totalPrice;
  return Math.round(priceWeightedPriceFactor);
};
